<template>
    <div :id="`toolbar_${id}`"
        style="display: inline-block; margin-top:5px; margin-bottom: 5px;"
        :style="toolbarStyle(id)"
    >
        <buttonCMP v-for="button in filteredButtons" :key="`${id}_${button.id}`" 
            v-show="buttonShow(button.id)"
            :color="buttonColor(button.id)"
            :id="`bt_${button.id}`" 
            :hint="button.hint"
            :img="dynamicRequire(button.img)"
            :disabled="!buttonEnabled(button.id)"
            :active="Boolean(buttonActive(button.id))"
            class="button"
            @click="buttonClick(button.id)"
        ></buttonCMP>

        <!-- @contextmenu.prevent.native="ACT_uiUpdate({ workArea : { imgBC : { reset : true } } })" -->
    </div>
</template>

<script>
const images = require.context('@/assets/imgs', false, /\.(gif|jpg|jpeg|png|svg)$/);

import { mapActions, mapGetters, mapState } from 'vuex';
import { undoRedoHistory } from '@/globals/undoRedo';
import { gConsts } from '@/globals/gConsts';
import { utils   } from '@/globals/utils';
import { evtBus  } from '@/main';

import buttonCMP from './button.vue';

// -----------------------------------------------------------------

export default {
    name : 'toolbarCMP',

    components : {
        buttonCMP
    },

    // -----------------------------------------------------------------\

    props: {
        buttons : Array,
        id : String
    }, 

    // -----------------------------------------------------------------\

    data () {
        return {
            currentLayerToolbar: []
        }
    },

    // -----------------------------------------------------------------\

    computed: {
        ...mapState([
        ]),

        ...mapGetters([
            'GET_togglesImgOrigin',
            'GET_togglesCrossHair',
            'GET_execModeVIEW',
            'GET_nodesArray'
        ]),   

        filteredButtons() {
            // if (this.id == gConsts.ui.toolbar.ids.ANNOT_TOOLS && this.currentLayerToolbar) {
            //     return this.buttons.filter(button => this.currentLayerToolbar.includes(button.id) || button.id == gConsts.ui.toolbar.buttons.DEL_TOOL);
            // }

            return this.buttons;
        }
    },

    // -----------------------------------------------------------------\

    methods: {
        ...mapActions([
            'ACT_toolDelete',
            'ACT_jobUpdate',
            'ACT_runtimeUpdate',
            'ACT_uiUpdate',
        ]),

        // -----------------------------------------------------------------

        dynamicRequire(img) {
            return images(`./${img}`);
        },

        // -----------------------------------------------------------------

        toolbarStyle(toolbar) {
            var style = '';

            // switch (toolbar) {
            //     case gConsts.ui.toolbar.ids.IMG_TOOLS   : style = { marginRight : '10px'}; break;

            //     case gConsts.ui.toolbar.ids.UNDO_REDO   : 
            //     case gConsts.ui.toolbar.ids.ANNOT_TOOLS : style = { marginRight : '50px'}; break;
                
            //     case gConsts.ui.toolbar.ids.OTHER       : style = { float : 'right'     }; break;
            // }

            return style;
        },

        // -----------------------------------------------------------------

        buttonShow : function(button) {
            var show = true;
            
            switch (button) {
                case gConsts.ui.toolbar.buttons.IMG_ORIGIN :
                    show = this.GET_activeElem && (this.GET_activeElem.imgOrigin != null);
                    break;
            }

            return show;
        },

        // -----------------------------------------------------------------

        buttonClick : function(button, toolType) {
            if (!this.buttonEnabled(button)) {
                return;
            }

            switch (button) {
                case gConsts.ui.toolbar.buttons.IMG_ORIGIN :
                    this.ACT_uiUpdate({ toggles : { imgOrigin : !this.GET_togglesImgOrigin } });
                    break;
                    
                case gConsts.ui.toolbar.buttons.FIT_TO_WA :
                    evtBus.$emit('evt_medidor_fitToWorkArea');
                    break;

                case gConsts.ui.toolbar.buttons.SAVE_IMG :
                    this.ACT_jobUpdate({});
                    break;

                case gConsts.ui.toolbar.buttons.CROSS_HAIR :
                    this.ACT_uiUpdate({ toggles : { crossHair : !this.GET_togglesCrossHair } });
                    break;

                case gConsts.ui.toolbar.buttons.UNDO : 
                    undoRedoHistory.undo();
                    break;

                case gConsts.ui.toolbar.buttons.REDO : 
                    undoRedoHistory.redo();
                    break;                                        

                case gConsts.ui.toolbar.buttons.DEL_TOOL : 
                    evtBus.$emit('evt_toolAction', 'deleteTool');
                    // this.ACT_toolDelete(); 
                    break;

                case gConsts.ui.toolbar.buttons.EXEC_MODE :
                    this.ACT_runtimeUpdate({ execMode : (this.GET_execModeVIEW ? gConsts.rt.execModes.WORK : gConsts.rt.execModes.VIEW) });
                    break;

                case gConsts.ui.toolbar.buttons.FULL_SCREEN : 
                    this.toggleFullscreen(this.$parent.$refs.rootElem);
                    break;
                    
                default :
                    this.ACT_uiUpdate({ toolbar : { 
                        toolType : utils.getButtonToolType(button),
                        button   : button
                    } });
            }
        },

        // -----------------------------------------------------------------

        toggleFullscreen(elem) {
            if (document.fullscreenElement) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else { 
                    this.fullScreen_pollyfill('exit');
                }                
            } else {
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else { 
                    this.fullScreen_pollyfill('req', elem);
                }                
            }
        },

        // -----------------------------------------------------------------

        fullScreen_pollyfill: function (action, elem) {
            switch (action) {
                case 'req' : 
                    if (elem.mozRequestFullScreen) { /* Firefox */
                        elem.mozRequestFullScreen();
                    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                        elem.webkitRequestFullscreen();
                    } else if (elem.msRequestFullscreen) { /* IE/Edge */
                        elem.msRequestFullscreen();
                    }
                    break;
                
                case 'exit' :
                    if (document.mozCancelFullScreen) { /* Firefox */
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) { /* Chrome, Safari & Opera */
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) { /* IE/Edge */
                        document.msExitFullscreen();
                    }
                    break;
            }
        },

        // -----------------------------------------------------------------

        buttonActive : function(button) {
            var active = false;
            // TODO: Desabilitado por enquanto ate refazer o undo/redo do store.
            if (this.id == gConsts.ui.toolbar.ids.UNDO_REDO) {
                return false;
            }

            switch (button) {
                case gConsts.ui.toolbar.buttons.IMG_ORIGIN :
                    active = this.GET_togglesImgOrigin;
                    break;

                case gConsts.ui.toolbar.buttons.CROSS_HAIR : 
                    active = this.GET_togglesCrossHair;
                    break;

                case gConsts.ui.toolbar.buttons.UNDO : 
                    active = undoRedoHistory.undoActive;
                    break;

                case gConsts.ui.toolbar.buttons.REDO : 
                    active = undoRedoHistory.redoActive;
                    break;

                case gConsts.ui.toolbar.buttons.EXEC_MODE :
                    active = this.GET_execModeVIEW;
                    break;

                default :
                    active = (this.$store.state.ui.toolbar.button == button);                    
            }
            
            return active;
        },

        buttonEnabled(buttonId) {
            // TODO: Desabilitado por enquanto ate refazer o salvamento do relatório.
            if (this.id == gConsts.ui.toolbar.ids.IMG_TOOLS && buttonId == gConsts.ui.toolbar.buttons.SAVE_IMG) {
                return false;
            }
            // TODO: Desabilitado por enquanto ate refazer o undo/redo do store.
            if (this.id == gConsts.ui.toolbar.ids.UNDO_REDO) {
                return false;
            }
            if (this.id == gConsts.ui.toolbar.ids.ANNOT_TOOLS) {
                if (this.currentLayerToolbar.length == 0) {
                    return false;
                }
                return this.currentLayerToolbar.includes(buttonId) || buttonId == gConsts.ui.toolbar.buttons.DEL_TOOL;
            }

            return true;
        },

        // -----------------------------------------------------------------

        buttonColor : function(button) {
            return (button == gConsts.ui.toolbar.buttons.DEL_TOOL) ? '#fa7575' : '';
        }

        // -----------------------------------------------------------------
    },

    // Lifecycle hooks
    created() {
        evtBus.$on('evt_activateNode', (payload) => {
            if (this.id == gConsts.ui.toolbar.ids.ANNOT_TOOLS) {
                const layerNode = this.GET_nodesArray.find(node => node.id == payload.layer);
                const labelNode = this.GET_nodesArray.find(node => node.id == payload.label);
                if (layerNode && layerNode.layerTools && labelNode) {
                    this.currentLayerToolbar = layerNode.layerTools.toolbar || [];

                    // Deseleciona o button tool se ele não fazer parte do toolbar da layer selecionada
                    if (![-1, gConsts.ui.toolbar.buttons.DEL_TOOL].includes(this.$store.state.ui.toolbar.button) &&
                        this.buttons.find(button => button.id == this.$store.state.ui.toolbar.button) &&
                        !this.currentLayerToolbar.includes(this.$store.state.ui.toolbar.button)) {
                        this.ACT_uiUpdate({ toolbar : { 
                            button : -1,
                            toolType : gConsts.tool.attrib.types.NO_TOOL
                        } });
                    }
                } else {
                    this.currentLayerToolbar = [];
                }
            }
        });
    },

    mounted() {
    },

    beforeDestroy() {
    }
}
</script>

<style scoped>
.button {
    width  : 30px;
    height : 25px;
}                 

.button[data-disabled="true"] {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #F3F4F6 !important;
}
</style>
